/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/_dashboard'
import { Route as AuthedOnboardingRouteRouteImport } from './routes/_authed/onboarding/route'
import { Route as AuthedDashboardIndexRouteImport } from './routes/_authed/_dashboard/index'
import { Route as AuthedOnboardingDomainRouteImport } from './routes/_authed/onboarding/domain'
import { Route as AuthedOnboardingBrandingRouteImport } from './routes/_authed/onboarding/branding'
import { Route as AuthedDashboardTravelAgencyRouteImport } from './routes/_authed/_dashboard/travel-agency'
import { Route as AuthedDashboardInboxRouteImport } from './routes/_authed/_dashboard/inbox'
import { Route as AuthedDashboardAssistantRouteImport } from './routes/_authed/_dashboard/assistant'
import { Route as AuthedDashboardReportingRouteRouteImport } from './routes/_authed/_dashboard/reporting/route'
import { Route as AuthedDashboardUsersIndexRouteImport } from './routes/_authed/_dashboard/users/index'
import { Route as AuthedDashboardTasksIndexRouteImport } from './routes/_authed/_dashboard/tasks/index'
import { Route as AuthedDashboardSignaturesIndexRouteImport } from './routes/_authed/_dashboard/signatures/index'
import { Route as AuthedDashboardReportingIndexRouteImport } from './routes/_authed/_dashboard/reporting/index'
import { Route as AuthedDashboardProceduresIndexRouteImport } from './routes/_authed/_dashboard/procedures/index'
import { Route as AuthedDashboardCompaniesIndexRouteImport } from './routes/_authed/_dashboard/companies/index'
import { Route as AuthedDashboardAgenciesIndexRouteImport } from './routes/_authed/_dashboard/agencies/index'
import { Route as AuthedDashboardAdminToolsIndexRouteImport } from './routes/_authed/_dashboard/admin-tools/index'
import { Route as AuthedDocumentsFileIdPdfRouteImport } from './routes/_authed/documents/$fileId.pdf'
import { Route as AuthedDocumentsFileIdEditRouteImport } from './routes/_authed/documents/$fileId.edit'
import { Route as AuthedDashboardReportingVolsRouteImport } from './routes/_authed/_dashboard/reporting/vols'
import { Route as AuthedDashboardReportingSignaturesRouteImport } from './routes/_authed/_dashboard/reporting/signatures'
import { Route as AuthedDashboardReportingRecouvrementRouteImport } from './routes/_authed/_dashboard/reporting/recouvrement'
import { Route as AuthedDashboardReportingPilotageRouteImport } from './routes/_authed/_dashboard/reporting/pilotage'
import { Route as AuthedDashboardReportingCommercialRouteImport } from './routes/_authed/_dashboard/reporting/commercial'
import { Route as AuthedDashboardClaimsCreateRouteImport } from './routes/_authed/_dashboard/claims/create'
import { Route as AuthedDashboardClaimsListRouteImport } from './routes/_authed/_dashboard/claims/_list'
import { Route as AuthedDashboardAdminToolsTimelineSearchRouteImport } from './routes/_authed/_dashboard/admin-tools/timeline-search'
import { Route as AuthedDashboardAdminToolsReportingRouteImport } from './routes/_authed/_dashboard/admin-tools/reporting'
import { Route as AuthedDashboardAdminToolsPaymentOrdersRouteImport } from './routes/_authed/_dashboard/admin-tools/payment-orders'
import { Route as AuthedDashboardAdminToolsMassAbandonRouteImport } from './routes/_authed/_dashboard/admin-tools/mass-abandon'
import { Route as AuthedDashboardAdminToolsFinanceRouteImport } from './routes/_authed/_dashboard/admin-tools/finance'
import { Route as AuthedDashboardAdminToolsFeatureFlagsRouteImport } from './routes/_authed/_dashboard/admin-tools/feature-flags'
import { Route as AuthedDashboardAdminToolsAllTasksRouteImport } from './routes/_authed/_dashboard/admin-tools/all-tasks'
import { Route as AuthedDashboardAdminToolsAgencyPaymentsRouteImport } from './routes/_authed/_dashboard/admin-tools/agency-payments'
import { Route as AuthedDashboardClaimsListIndexRouteImport } from './routes/_authed/_dashboard/claims/_list/index'
import { Route as AuthedDashboardClaimsClaimIdIndexRouteImport } from './routes/_authed/_dashboard/claims/$claimId/index'
import { Route as AuthedDashboardClaimsClaimIdTimelineRouteImport } from './routes/_authed/_dashboard/claims/$claimId/timeline'
import { Route as AuthedDashboardClaimsClaimIdPnrDisplayRouteImport } from './routes/_authed/_dashboard/claims/$claimId/pnr-display'
import { Route as AuthedDashboardClaimsClaimIdPassengersRouteImport } from './routes/_authed/_dashboard/claims/$claimId/passengers'
import { Route as AuthedDashboardClaimsClaimIdOverviewRouteImport } from './routes/_authed/_dashboard/claims/$claimId/overview'
import { Route as AuthedDashboardClaimsClaimIdAcquisitionHistoryRouteImport } from './routes/_authed/_dashboard/claims/$claimId/acquisition-history'
import { Route as AuthedDashboardClaimsListClaimIdFilesRouteImport } from './routes/_authed/_dashboard/claims/_list/$claimId.files'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOnboardingRouteRoute = AuthedOnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardIndexRoute = AuthedDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedOnboardingDomainRoute = AuthedOnboardingDomainRouteImport.update({
  id: '/domain',
  path: '/domain',
  getParentRoute: () => AuthedOnboardingRouteRoute,
} as any)
const AuthedOnboardingBrandingRoute =
  AuthedOnboardingBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AuthedOnboardingRouteRoute,
  } as any)
const AuthedDashboardTravelAgencyRoute =
  AuthedDashboardTravelAgencyRouteImport.update({
    id: '/travel-agency',
    path: '/travel-agency',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardInboxRoute = AuthedDashboardInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const AuthedDashboardAssistantRoute =
  AuthedDashboardAssistantRouteImport.update({
    id: '/assistant',
    path: '/assistant',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardReportingRouteRoute =
  AuthedDashboardReportingRouteRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardUsersIndexRoute =
  AuthedDashboardUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardTasksIndexRoute =
  AuthedDashboardTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardSignaturesIndexRoute =
  AuthedDashboardSignaturesIndexRouteImport.update({
    id: '/signatures/',
    path: '/signatures/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardReportingIndexRoute =
  AuthedDashboardReportingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardReportingRouteRoute,
  } as any)
const AuthedDashboardProceduresIndexRoute =
  AuthedDashboardProceduresIndexRouteImport.update({
    id: '/procedures/',
    path: '/procedures/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardCompaniesIndexRoute =
  AuthedDashboardCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAgenciesIndexRoute =
  AuthedDashboardAgenciesIndexRouteImport.update({
    id: '/agencies/',
    path: '/agencies/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsIndexRoute =
  AuthedDashboardAdminToolsIndexRouteImport.update({
    id: '/admin-tools/',
    path: '/admin-tools/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDocumentsFileIdPdfRoute =
  AuthedDocumentsFileIdPdfRouteImport.update({
    id: '/documents/$fileId/pdf',
    path: '/documents/$fileId/pdf',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDocumentsFileIdEditRoute =
  AuthedDocumentsFileIdEditRouteImport.update({
    id: '/documents/$fileId/edit',
    path: '/documents/$fileId/edit',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDashboardReportingVolsRoute =
  AuthedDashboardReportingVolsRouteImport.update({
    id: '/vols',
    path: '/vols',
    getParentRoute: () => AuthedDashboardReportingRouteRoute,
  } as any)
const AuthedDashboardReportingSignaturesRoute =
  AuthedDashboardReportingSignaturesRouteImport.update({
    id: '/signatures',
    path: '/signatures',
    getParentRoute: () => AuthedDashboardReportingRouteRoute,
  } as any)
const AuthedDashboardReportingRecouvrementRoute =
  AuthedDashboardReportingRecouvrementRouteImport.update({
    id: '/recouvrement',
    path: '/recouvrement',
    getParentRoute: () => AuthedDashboardReportingRouteRoute,
  } as any)
const AuthedDashboardReportingPilotageRoute =
  AuthedDashboardReportingPilotageRouteImport.update({
    id: '/pilotage',
    path: '/pilotage',
    getParentRoute: () => AuthedDashboardReportingRouteRoute,
  } as any)
const AuthedDashboardReportingCommercialRoute =
  AuthedDashboardReportingCommercialRouteImport.update({
    id: '/commercial',
    path: '/commercial',
    getParentRoute: () => AuthedDashboardReportingRouteRoute,
  } as any)
const AuthedDashboardClaimsCreateRoute =
  AuthedDashboardClaimsCreateRouteImport.update({
    id: '/claims/create',
    path: '/claims/create',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardClaimsListRoute =
  AuthedDashboardClaimsListRouteImport.update({
    id: '/claims/_list',
    path: '/claims',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsTimelineSearchRoute =
  AuthedDashboardAdminToolsTimelineSearchRouteImport.update({
    id: '/admin-tools/timeline-search',
    path: '/admin-tools/timeline-search',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsReportingRoute =
  AuthedDashboardAdminToolsReportingRouteImport.update({
    id: '/admin-tools/reporting',
    path: '/admin-tools/reporting',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsPaymentOrdersRoute =
  AuthedDashboardAdminToolsPaymentOrdersRouteImport.update({
    id: '/admin-tools/payment-orders',
    path: '/admin-tools/payment-orders',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsMassAbandonRoute =
  AuthedDashboardAdminToolsMassAbandonRouteImport.update({
    id: '/admin-tools/mass-abandon',
    path: '/admin-tools/mass-abandon',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsFinanceRoute =
  AuthedDashboardAdminToolsFinanceRouteImport.update({
    id: '/admin-tools/finance',
    path: '/admin-tools/finance',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsFeatureFlagsRoute =
  AuthedDashboardAdminToolsFeatureFlagsRouteImport.update({
    id: '/admin-tools/feature-flags',
    path: '/admin-tools/feature-flags',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsAllTasksRoute =
  AuthedDashboardAdminToolsAllTasksRouteImport.update({
    id: '/admin-tools/all-tasks',
    path: '/admin-tools/all-tasks',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardAdminToolsAgencyPaymentsRoute =
  AuthedDashboardAdminToolsAgencyPaymentsRouteImport.update({
    id: '/admin-tools/agency-payments',
    path: '/admin-tools/agency-payments',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardClaimsListIndexRoute =
  AuthedDashboardClaimsListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardClaimsListRoute,
  } as any)
const AuthedDashboardClaimsClaimIdIndexRoute =
  AuthedDashboardClaimsClaimIdIndexRouteImport.update({
    id: '/claims/$claimId/',
    path: '/claims/$claimId/',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardClaimsClaimIdTimelineRoute =
  AuthedDashboardClaimsClaimIdTimelineRouteImport.update({
    id: '/claims/$claimId/timeline',
    path: '/claims/$claimId/timeline',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardClaimsClaimIdPnrDisplayRoute =
  AuthedDashboardClaimsClaimIdPnrDisplayRouteImport.update({
    id: '/claims/$claimId/pnr-display',
    path: '/claims/$claimId/pnr-display',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardClaimsClaimIdPassengersRoute =
  AuthedDashboardClaimsClaimIdPassengersRouteImport.update({
    id: '/claims/$claimId/passengers',
    path: '/claims/$claimId/passengers',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardClaimsClaimIdOverviewRoute =
  AuthedDashboardClaimsClaimIdOverviewRouteImport.update({
    id: '/claims/$claimId/overview',
    path: '/claims/$claimId/overview',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardClaimsClaimIdAcquisitionHistoryRoute =
  AuthedDashboardClaimsClaimIdAcquisitionHistoryRouteImport.update({
    id: '/claims/$claimId/acquisition-history',
    path: '/claims/$claimId/acquisition-history',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardClaimsListClaimIdFilesRoute =
  AuthedDashboardClaimsListClaimIdFilesRouteImport.update({
    id: '/$claimId/files',
    path: '/$claimId/files',
    getParentRoute: () => AuthedDashboardClaimsListRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedDashboardIndexRoute
  '/onboarding': typeof AuthedOnboardingRouteRouteWithChildren
  '/reporting': typeof AuthedDashboardReportingRouteRouteWithChildren
  '/assistant': typeof AuthedDashboardAssistantRoute
  '/inbox': typeof AuthedDashboardInboxRoute
  '/travel-agency': typeof AuthedDashboardTravelAgencyRoute
  '/onboarding/branding': typeof AuthedOnboardingBrandingRoute
  '/onboarding/domain': typeof AuthedOnboardingDomainRoute
  '/admin-tools/agency-payments': typeof AuthedDashboardAdminToolsAgencyPaymentsRoute
  '/admin-tools/all-tasks': typeof AuthedDashboardAdminToolsAllTasksRoute
  '/admin-tools/feature-flags': typeof AuthedDashboardAdminToolsFeatureFlagsRoute
  '/admin-tools/finance': typeof AuthedDashboardAdminToolsFinanceRoute
  '/admin-tools/mass-abandon': typeof AuthedDashboardAdminToolsMassAbandonRoute
  '/admin-tools/payment-orders': typeof AuthedDashboardAdminToolsPaymentOrdersRoute
  '/admin-tools/reporting': typeof AuthedDashboardAdminToolsReportingRoute
  '/admin-tools/timeline-search': typeof AuthedDashboardAdminToolsTimelineSearchRoute
  '/claims': typeof AuthedDashboardClaimsListRouteWithChildren
  '/claims/create': typeof AuthedDashboardClaimsCreateRoute
  '/reporting/commercial': typeof AuthedDashboardReportingCommercialRoute
  '/reporting/pilotage': typeof AuthedDashboardReportingPilotageRoute
  '/reporting/recouvrement': typeof AuthedDashboardReportingRecouvrementRoute
  '/reporting/signatures': typeof AuthedDashboardReportingSignaturesRoute
  '/reporting/vols': typeof AuthedDashboardReportingVolsRoute
  '/documents/$fileId/edit': typeof AuthedDocumentsFileIdEditRoute
  '/documents/$fileId/pdf': typeof AuthedDocumentsFileIdPdfRoute
  '/admin-tools/': typeof AuthedDashboardAdminToolsIndexRoute
  '/agencies/': typeof AuthedDashboardAgenciesIndexRoute
  '/companies/': typeof AuthedDashboardCompaniesIndexRoute
  '/procedures/': typeof AuthedDashboardProceduresIndexRoute
  '/reporting/': typeof AuthedDashboardReportingIndexRoute
  '/signatures/': typeof AuthedDashboardSignaturesIndexRoute
  '/tasks/': typeof AuthedDashboardTasksIndexRoute
  '/users/': typeof AuthedDashboardUsersIndexRoute
  '/claims/$claimId/acquisition-history': typeof AuthedDashboardClaimsClaimIdAcquisitionHistoryRoute
  '/claims/$claimId/overview': typeof AuthedDashboardClaimsClaimIdOverviewRoute
  '/claims/$claimId/passengers': typeof AuthedDashboardClaimsClaimIdPassengersRoute
  '/claims/$claimId/pnr-display': typeof AuthedDashboardClaimsClaimIdPnrDisplayRoute
  '/claims/$claimId/timeline': typeof AuthedDashboardClaimsClaimIdTimelineRoute
  '/claims/$claimId/': typeof AuthedDashboardClaimsClaimIdIndexRoute
  '/claims/': typeof AuthedDashboardClaimsListIndexRoute
  '/claims/$claimId/files': typeof AuthedDashboardClaimsListClaimIdFilesRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedDashboardIndexRoute
  '/onboarding': typeof AuthedOnboardingRouteRouteWithChildren
  '/assistant': typeof AuthedDashboardAssistantRoute
  '/inbox': typeof AuthedDashboardInboxRoute
  '/travel-agency': typeof AuthedDashboardTravelAgencyRoute
  '/onboarding/branding': typeof AuthedOnboardingBrandingRoute
  '/onboarding/domain': typeof AuthedOnboardingDomainRoute
  '/admin-tools/agency-payments': typeof AuthedDashboardAdminToolsAgencyPaymentsRoute
  '/admin-tools/all-tasks': typeof AuthedDashboardAdminToolsAllTasksRoute
  '/admin-tools/feature-flags': typeof AuthedDashboardAdminToolsFeatureFlagsRoute
  '/admin-tools/finance': typeof AuthedDashboardAdminToolsFinanceRoute
  '/admin-tools/mass-abandon': typeof AuthedDashboardAdminToolsMassAbandonRoute
  '/admin-tools/payment-orders': typeof AuthedDashboardAdminToolsPaymentOrdersRoute
  '/admin-tools/reporting': typeof AuthedDashboardAdminToolsReportingRoute
  '/admin-tools/timeline-search': typeof AuthedDashboardAdminToolsTimelineSearchRoute
  '/claims/create': typeof AuthedDashboardClaimsCreateRoute
  '/reporting/commercial': typeof AuthedDashboardReportingCommercialRoute
  '/reporting/pilotage': typeof AuthedDashboardReportingPilotageRoute
  '/reporting/recouvrement': typeof AuthedDashboardReportingRecouvrementRoute
  '/reporting/signatures': typeof AuthedDashboardReportingSignaturesRoute
  '/reporting/vols': typeof AuthedDashboardReportingVolsRoute
  '/documents/$fileId/edit': typeof AuthedDocumentsFileIdEditRoute
  '/documents/$fileId/pdf': typeof AuthedDocumentsFileIdPdfRoute
  '/admin-tools': typeof AuthedDashboardAdminToolsIndexRoute
  '/agencies': typeof AuthedDashboardAgenciesIndexRoute
  '/companies': typeof AuthedDashboardCompaniesIndexRoute
  '/procedures': typeof AuthedDashboardProceduresIndexRoute
  '/reporting': typeof AuthedDashboardReportingIndexRoute
  '/signatures': typeof AuthedDashboardSignaturesIndexRoute
  '/tasks': typeof AuthedDashboardTasksIndexRoute
  '/users': typeof AuthedDashboardUsersIndexRoute
  '/claims/$claimId/acquisition-history': typeof AuthedDashboardClaimsClaimIdAcquisitionHistoryRoute
  '/claims/$claimId/overview': typeof AuthedDashboardClaimsClaimIdOverviewRoute
  '/claims/$claimId/passengers': typeof AuthedDashboardClaimsClaimIdPassengersRoute
  '/claims/$claimId/pnr-display': typeof AuthedDashboardClaimsClaimIdPnrDisplayRoute
  '/claims/$claimId/timeline': typeof AuthedDashboardClaimsClaimIdTimelineRoute
  '/claims/$claimId': typeof AuthedDashboardClaimsClaimIdIndexRoute
  '/claims': typeof AuthedDashboardClaimsListIndexRoute
  '/claims/$claimId/files': typeof AuthedDashboardClaimsListClaimIdFilesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_authed/onboarding': typeof AuthedOnboardingRouteRouteWithChildren
  '/_authed/_dashboard': typeof AuthedDashboardRouteWithChildren
  '/_authed/_dashboard/reporting': typeof AuthedDashboardReportingRouteRouteWithChildren
  '/_authed/_dashboard/assistant': typeof AuthedDashboardAssistantRoute
  '/_authed/_dashboard/inbox': typeof AuthedDashboardInboxRoute
  '/_authed/_dashboard/travel-agency': typeof AuthedDashboardTravelAgencyRoute
  '/_authed/onboarding/branding': typeof AuthedOnboardingBrandingRoute
  '/_authed/onboarding/domain': typeof AuthedOnboardingDomainRoute
  '/_authed/_dashboard/': typeof AuthedDashboardIndexRoute
  '/_authed/_dashboard/admin-tools/agency-payments': typeof AuthedDashboardAdminToolsAgencyPaymentsRoute
  '/_authed/_dashboard/admin-tools/all-tasks': typeof AuthedDashboardAdminToolsAllTasksRoute
  '/_authed/_dashboard/admin-tools/feature-flags': typeof AuthedDashboardAdminToolsFeatureFlagsRoute
  '/_authed/_dashboard/admin-tools/finance': typeof AuthedDashboardAdminToolsFinanceRoute
  '/_authed/_dashboard/admin-tools/mass-abandon': typeof AuthedDashboardAdminToolsMassAbandonRoute
  '/_authed/_dashboard/admin-tools/payment-orders': typeof AuthedDashboardAdminToolsPaymentOrdersRoute
  '/_authed/_dashboard/admin-tools/reporting': typeof AuthedDashboardAdminToolsReportingRoute
  '/_authed/_dashboard/admin-tools/timeline-search': typeof AuthedDashboardAdminToolsTimelineSearchRoute
  '/_authed/_dashboard/claims/_list': typeof AuthedDashboardClaimsListRouteWithChildren
  '/_authed/_dashboard/claims/create': typeof AuthedDashboardClaimsCreateRoute
  '/_authed/_dashboard/reporting/commercial': typeof AuthedDashboardReportingCommercialRoute
  '/_authed/_dashboard/reporting/pilotage': typeof AuthedDashboardReportingPilotageRoute
  '/_authed/_dashboard/reporting/recouvrement': typeof AuthedDashboardReportingRecouvrementRoute
  '/_authed/_dashboard/reporting/signatures': typeof AuthedDashboardReportingSignaturesRoute
  '/_authed/_dashboard/reporting/vols': typeof AuthedDashboardReportingVolsRoute
  '/_authed/documents/$fileId/edit': typeof AuthedDocumentsFileIdEditRoute
  '/_authed/documents/$fileId/pdf': typeof AuthedDocumentsFileIdPdfRoute
  '/_authed/_dashboard/admin-tools/': typeof AuthedDashboardAdminToolsIndexRoute
  '/_authed/_dashboard/agencies/': typeof AuthedDashboardAgenciesIndexRoute
  '/_authed/_dashboard/companies/': typeof AuthedDashboardCompaniesIndexRoute
  '/_authed/_dashboard/procedures/': typeof AuthedDashboardProceduresIndexRoute
  '/_authed/_dashboard/reporting/': typeof AuthedDashboardReportingIndexRoute
  '/_authed/_dashboard/signatures/': typeof AuthedDashboardSignaturesIndexRoute
  '/_authed/_dashboard/tasks/': typeof AuthedDashboardTasksIndexRoute
  '/_authed/_dashboard/users/': typeof AuthedDashboardUsersIndexRoute
  '/_authed/_dashboard/claims/$claimId/acquisition-history': typeof AuthedDashboardClaimsClaimIdAcquisitionHistoryRoute
  '/_authed/_dashboard/claims/$claimId/overview': typeof AuthedDashboardClaimsClaimIdOverviewRoute
  '/_authed/_dashboard/claims/$claimId/passengers': typeof AuthedDashboardClaimsClaimIdPassengersRoute
  '/_authed/_dashboard/claims/$claimId/pnr-display': typeof AuthedDashboardClaimsClaimIdPnrDisplayRoute
  '/_authed/_dashboard/claims/$claimId/timeline': typeof AuthedDashboardClaimsClaimIdTimelineRoute
  '/_authed/_dashboard/claims/$claimId/': typeof AuthedDashboardClaimsClaimIdIndexRoute
  '/_authed/_dashboard/claims/_list/': typeof AuthedDashboardClaimsListIndexRoute
  '/_authed/_dashboard/claims/_list/$claimId/files': typeof AuthedDashboardClaimsListClaimIdFilesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/reporting'
    | '/assistant'
    | '/inbox'
    | '/travel-agency'
    | '/onboarding/branding'
    | '/onboarding/domain'
    | '/admin-tools/agency-payments'
    | '/admin-tools/all-tasks'
    | '/admin-tools/feature-flags'
    | '/admin-tools/finance'
    | '/admin-tools/mass-abandon'
    | '/admin-tools/payment-orders'
    | '/admin-tools/reporting'
    | '/admin-tools/timeline-search'
    | '/claims'
    | '/claims/create'
    | '/reporting/commercial'
    | '/reporting/pilotage'
    | '/reporting/recouvrement'
    | '/reporting/signatures'
    | '/reporting/vols'
    | '/documents/$fileId/edit'
    | '/documents/$fileId/pdf'
    | '/admin-tools/'
    | '/agencies/'
    | '/companies/'
    | '/procedures/'
    | '/reporting/'
    | '/signatures/'
    | '/tasks/'
    | '/users/'
    | '/claims/$claimId/acquisition-history'
    | '/claims/$claimId/overview'
    | '/claims/$claimId/passengers'
    | '/claims/$claimId/pnr-display'
    | '/claims/$claimId/timeline'
    | '/claims/$claimId/'
    | '/claims/'
    | '/claims/$claimId/files'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/assistant'
    | '/inbox'
    | '/travel-agency'
    | '/onboarding/branding'
    | '/onboarding/domain'
    | '/admin-tools/agency-payments'
    | '/admin-tools/all-tasks'
    | '/admin-tools/feature-flags'
    | '/admin-tools/finance'
    | '/admin-tools/mass-abandon'
    | '/admin-tools/payment-orders'
    | '/admin-tools/reporting'
    | '/admin-tools/timeline-search'
    | '/claims/create'
    | '/reporting/commercial'
    | '/reporting/pilotage'
    | '/reporting/recouvrement'
    | '/reporting/signatures'
    | '/reporting/vols'
    | '/documents/$fileId/edit'
    | '/documents/$fileId/pdf'
    | '/admin-tools'
    | '/agencies'
    | '/companies'
    | '/procedures'
    | '/reporting'
    | '/signatures'
    | '/tasks'
    | '/users'
    | '/claims/$claimId/acquisition-history'
    | '/claims/$claimId/overview'
    | '/claims/$claimId/passengers'
    | '/claims/$claimId/pnr-display'
    | '/claims/$claimId/timeline'
    | '/claims/$claimId'
    | '/claims'
    | '/claims/$claimId/files'
  id:
    | '__root__'
    | '/_authed'
    | '/_authed/onboarding'
    | '/_authed/_dashboard'
    | '/_authed/_dashboard/reporting'
    | '/_authed/_dashboard/assistant'
    | '/_authed/_dashboard/inbox'
    | '/_authed/_dashboard/travel-agency'
    | '/_authed/onboarding/branding'
    | '/_authed/onboarding/domain'
    | '/_authed/_dashboard/'
    | '/_authed/_dashboard/admin-tools/agency-payments'
    | '/_authed/_dashboard/admin-tools/all-tasks'
    | '/_authed/_dashboard/admin-tools/feature-flags'
    | '/_authed/_dashboard/admin-tools/finance'
    | '/_authed/_dashboard/admin-tools/mass-abandon'
    | '/_authed/_dashboard/admin-tools/payment-orders'
    | '/_authed/_dashboard/admin-tools/reporting'
    | '/_authed/_dashboard/admin-tools/timeline-search'
    | '/_authed/_dashboard/claims/_list'
    | '/_authed/_dashboard/claims/create'
    | '/_authed/_dashboard/reporting/commercial'
    | '/_authed/_dashboard/reporting/pilotage'
    | '/_authed/_dashboard/reporting/recouvrement'
    | '/_authed/_dashboard/reporting/signatures'
    | '/_authed/_dashboard/reporting/vols'
    | '/_authed/documents/$fileId/edit'
    | '/_authed/documents/$fileId/pdf'
    | '/_authed/_dashboard/admin-tools/'
    | '/_authed/_dashboard/agencies/'
    | '/_authed/_dashboard/companies/'
    | '/_authed/_dashboard/procedures/'
    | '/_authed/_dashboard/reporting/'
    | '/_authed/_dashboard/signatures/'
    | '/_authed/_dashboard/tasks/'
    | '/_authed/_dashboard/users/'
    | '/_authed/_dashboard/claims/$claimId/acquisition-history'
    | '/_authed/_dashboard/claims/$claimId/overview'
    | '/_authed/_dashboard/claims/$claimId/passengers'
    | '/_authed/_dashboard/claims/$claimId/pnr-display'
    | '/_authed/_dashboard/claims/$claimId/timeline'
    | '/_authed/_dashboard/claims/$claimId/'
    | '/_authed/_dashboard/claims/_list/'
    | '/_authed/_dashboard/claims/_list/$claimId/files'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/_dashboard': {
      id: '/_authed/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/onboarding': {
      id: '/_authed/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthedOnboardingRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_dashboard/': {
      id: '/_authed/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedDashboardIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/onboarding/domain': {
      id: '/_authed/onboarding/domain'
      path: '/domain'
      fullPath: '/onboarding/domain'
      preLoaderRoute: typeof AuthedOnboardingDomainRouteImport
      parentRoute: typeof AuthedOnboardingRouteRoute
    }
    '/_authed/onboarding/branding': {
      id: '/_authed/onboarding/branding'
      path: '/branding'
      fullPath: '/onboarding/branding'
      preLoaderRoute: typeof AuthedOnboardingBrandingRouteImport
      parentRoute: typeof AuthedOnboardingRouteRoute
    }
    '/_authed/_dashboard/travel-agency': {
      id: '/_authed/_dashboard/travel-agency'
      path: '/travel-agency'
      fullPath: '/travel-agency'
      preLoaderRoute: typeof AuthedDashboardTravelAgencyRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/inbox': {
      id: '/_authed/_dashboard/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthedDashboardInboxRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/assistant': {
      id: '/_authed/_dashboard/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AuthedDashboardAssistantRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/reporting': {
      id: '/_authed/_dashboard/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof AuthedDashboardReportingRouteRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/users/': {
      id: '/_authed/_dashboard/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedDashboardUsersIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/tasks/': {
      id: '/_authed/_dashboard/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthedDashboardTasksIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/signatures/': {
      id: '/_authed/_dashboard/signatures/'
      path: '/signatures'
      fullPath: '/signatures/'
      preLoaderRoute: typeof AuthedDashboardSignaturesIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/reporting/': {
      id: '/_authed/_dashboard/reporting/'
      path: '/'
      fullPath: '/reporting/'
      preLoaderRoute: typeof AuthedDashboardReportingIndexRouteImport
      parentRoute: typeof AuthedDashboardReportingRouteRoute
    }
    '/_authed/_dashboard/procedures/': {
      id: '/_authed/_dashboard/procedures/'
      path: '/procedures'
      fullPath: '/procedures/'
      preLoaderRoute: typeof AuthedDashboardProceduresIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/companies/': {
      id: '/_authed/_dashboard/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthedDashboardCompaniesIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/agencies/': {
      id: '/_authed/_dashboard/agencies/'
      path: '/agencies'
      fullPath: '/agencies/'
      preLoaderRoute: typeof AuthedDashboardAgenciesIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/': {
      id: '/_authed/_dashboard/admin-tools/'
      path: '/admin-tools'
      fullPath: '/admin-tools/'
      preLoaderRoute: typeof AuthedDashboardAdminToolsIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/documents/$fileId/pdf': {
      id: '/_authed/documents/$fileId/pdf'
      path: '/documents/$fileId/pdf'
      fullPath: '/documents/$fileId/pdf'
      preLoaderRoute: typeof AuthedDocumentsFileIdPdfRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/documents/$fileId/edit': {
      id: '/_authed/documents/$fileId/edit'
      path: '/documents/$fileId/edit'
      fullPath: '/documents/$fileId/edit'
      preLoaderRoute: typeof AuthedDocumentsFileIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_dashboard/reporting/vols': {
      id: '/_authed/_dashboard/reporting/vols'
      path: '/vols'
      fullPath: '/reporting/vols'
      preLoaderRoute: typeof AuthedDashboardReportingVolsRouteImport
      parentRoute: typeof AuthedDashboardReportingRouteRoute
    }
    '/_authed/_dashboard/reporting/signatures': {
      id: '/_authed/_dashboard/reporting/signatures'
      path: '/signatures'
      fullPath: '/reporting/signatures'
      preLoaderRoute: typeof AuthedDashboardReportingSignaturesRouteImport
      parentRoute: typeof AuthedDashboardReportingRouteRoute
    }
    '/_authed/_dashboard/reporting/recouvrement': {
      id: '/_authed/_dashboard/reporting/recouvrement'
      path: '/recouvrement'
      fullPath: '/reporting/recouvrement'
      preLoaderRoute: typeof AuthedDashboardReportingRecouvrementRouteImport
      parentRoute: typeof AuthedDashboardReportingRouteRoute
    }
    '/_authed/_dashboard/reporting/pilotage': {
      id: '/_authed/_dashboard/reporting/pilotage'
      path: '/pilotage'
      fullPath: '/reporting/pilotage'
      preLoaderRoute: typeof AuthedDashboardReportingPilotageRouteImport
      parentRoute: typeof AuthedDashboardReportingRouteRoute
    }
    '/_authed/_dashboard/reporting/commercial': {
      id: '/_authed/_dashboard/reporting/commercial'
      path: '/commercial'
      fullPath: '/reporting/commercial'
      preLoaderRoute: typeof AuthedDashboardReportingCommercialRouteImport
      parentRoute: typeof AuthedDashboardReportingRouteRoute
    }
    '/_authed/_dashboard/claims/create': {
      id: '/_authed/_dashboard/claims/create'
      path: '/claims/create'
      fullPath: '/claims/create'
      preLoaderRoute: typeof AuthedDashboardClaimsCreateRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/claims/_list': {
      id: '/_authed/_dashboard/claims/_list'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AuthedDashboardClaimsListRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/timeline-search': {
      id: '/_authed/_dashboard/admin-tools/timeline-search'
      path: '/admin-tools/timeline-search'
      fullPath: '/admin-tools/timeline-search'
      preLoaderRoute: typeof AuthedDashboardAdminToolsTimelineSearchRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/reporting': {
      id: '/_authed/_dashboard/admin-tools/reporting'
      path: '/admin-tools/reporting'
      fullPath: '/admin-tools/reporting'
      preLoaderRoute: typeof AuthedDashboardAdminToolsReportingRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/payment-orders': {
      id: '/_authed/_dashboard/admin-tools/payment-orders'
      path: '/admin-tools/payment-orders'
      fullPath: '/admin-tools/payment-orders'
      preLoaderRoute: typeof AuthedDashboardAdminToolsPaymentOrdersRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/mass-abandon': {
      id: '/_authed/_dashboard/admin-tools/mass-abandon'
      path: '/admin-tools/mass-abandon'
      fullPath: '/admin-tools/mass-abandon'
      preLoaderRoute: typeof AuthedDashboardAdminToolsMassAbandonRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/finance': {
      id: '/_authed/_dashboard/admin-tools/finance'
      path: '/admin-tools/finance'
      fullPath: '/admin-tools/finance'
      preLoaderRoute: typeof AuthedDashboardAdminToolsFinanceRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/feature-flags': {
      id: '/_authed/_dashboard/admin-tools/feature-flags'
      path: '/admin-tools/feature-flags'
      fullPath: '/admin-tools/feature-flags'
      preLoaderRoute: typeof AuthedDashboardAdminToolsFeatureFlagsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/all-tasks': {
      id: '/_authed/_dashboard/admin-tools/all-tasks'
      path: '/admin-tools/all-tasks'
      fullPath: '/admin-tools/all-tasks'
      preLoaderRoute: typeof AuthedDashboardAdminToolsAllTasksRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/admin-tools/agency-payments': {
      id: '/_authed/_dashboard/admin-tools/agency-payments'
      path: '/admin-tools/agency-payments'
      fullPath: '/admin-tools/agency-payments'
      preLoaderRoute: typeof AuthedDashboardAdminToolsAgencyPaymentsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/claims/_list/': {
      id: '/_authed/_dashboard/claims/_list/'
      path: '/'
      fullPath: '/claims/'
      preLoaderRoute: typeof AuthedDashboardClaimsListIndexRouteImport
      parentRoute: typeof AuthedDashboardClaimsListRoute
    }
    '/_authed/_dashboard/claims/$claimId/': {
      id: '/_authed/_dashboard/claims/$claimId/'
      path: '/claims/$claimId'
      fullPath: '/claims/$claimId/'
      preLoaderRoute: typeof AuthedDashboardClaimsClaimIdIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/claims/$claimId/timeline': {
      id: '/_authed/_dashboard/claims/$claimId/timeline'
      path: '/claims/$claimId/timeline'
      fullPath: '/claims/$claimId/timeline'
      preLoaderRoute: typeof AuthedDashboardClaimsClaimIdTimelineRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/claims/$claimId/pnr-display': {
      id: '/_authed/_dashboard/claims/$claimId/pnr-display'
      path: '/claims/$claimId/pnr-display'
      fullPath: '/claims/$claimId/pnr-display'
      preLoaderRoute: typeof AuthedDashboardClaimsClaimIdPnrDisplayRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/claims/$claimId/passengers': {
      id: '/_authed/_dashboard/claims/$claimId/passengers'
      path: '/claims/$claimId/passengers'
      fullPath: '/claims/$claimId/passengers'
      preLoaderRoute: typeof AuthedDashboardClaimsClaimIdPassengersRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/claims/$claimId/overview': {
      id: '/_authed/_dashboard/claims/$claimId/overview'
      path: '/claims/$claimId/overview'
      fullPath: '/claims/$claimId/overview'
      preLoaderRoute: typeof AuthedDashboardClaimsClaimIdOverviewRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/claims/$claimId/acquisition-history': {
      id: '/_authed/_dashboard/claims/$claimId/acquisition-history'
      path: '/claims/$claimId/acquisition-history'
      fullPath: '/claims/$claimId/acquisition-history'
      preLoaderRoute: typeof AuthedDashboardClaimsClaimIdAcquisitionHistoryRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/_dashboard/claims/_list/$claimId/files': {
      id: '/_authed/_dashboard/claims/_list/$claimId/files'
      path: '/$claimId/files'
      fullPath: '/claims/$claimId/files'
      preLoaderRoute: typeof AuthedDashboardClaimsListClaimIdFilesRouteImport
      parentRoute: typeof AuthedDashboardClaimsListRoute
    }
  }
}

interface AuthedOnboardingRouteRouteChildren {
  AuthedOnboardingBrandingRoute: typeof AuthedOnboardingBrandingRoute
  AuthedOnboardingDomainRoute: typeof AuthedOnboardingDomainRoute
}

const AuthedOnboardingRouteRouteChildren: AuthedOnboardingRouteRouteChildren = {
  AuthedOnboardingBrandingRoute: AuthedOnboardingBrandingRoute,
  AuthedOnboardingDomainRoute: AuthedOnboardingDomainRoute,
}

const AuthedOnboardingRouteRouteWithChildren =
  AuthedOnboardingRouteRoute._addFileChildren(
    AuthedOnboardingRouteRouteChildren,
  )

interface AuthedDashboardReportingRouteRouteChildren {
  AuthedDashboardReportingCommercialRoute: typeof AuthedDashboardReportingCommercialRoute
  AuthedDashboardReportingPilotageRoute: typeof AuthedDashboardReportingPilotageRoute
  AuthedDashboardReportingRecouvrementRoute: typeof AuthedDashboardReportingRecouvrementRoute
  AuthedDashboardReportingSignaturesRoute: typeof AuthedDashboardReportingSignaturesRoute
  AuthedDashboardReportingVolsRoute: typeof AuthedDashboardReportingVolsRoute
  AuthedDashboardReportingIndexRoute: typeof AuthedDashboardReportingIndexRoute
}

const AuthedDashboardReportingRouteRouteChildren: AuthedDashboardReportingRouteRouteChildren =
  {
    AuthedDashboardReportingCommercialRoute:
      AuthedDashboardReportingCommercialRoute,
    AuthedDashboardReportingPilotageRoute:
      AuthedDashboardReportingPilotageRoute,
    AuthedDashboardReportingRecouvrementRoute:
      AuthedDashboardReportingRecouvrementRoute,
    AuthedDashboardReportingSignaturesRoute:
      AuthedDashboardReportingSignaturesRoute,
    AuthedDashboardReportingVolsRoute: AuthedDashboardReportingVolsRoute,
    AuthedDashboardReportingIndexRoute: AuthedDashboardReportingIndexRoute,
  }

const AuthedDashboardReportingRouteRouteWithChildren =
  AuthedDashboardReportingRouteRoute._addFileChildren(
    AuthedDashboardReportingRouteRouteChildren,
  )

interface AuthedDashboardClaimsListRouteChildren {
  AuthedDashboardClaimsListIndexRoute: typeof AuthedDashboardClaimsListIndexRoute
  AuthedDashboardClaimsListClaimIdFilesRoute: typeof AuthedDashboardClaimsListClaimIdFilesRoute
}

const AuthedDashboardClaimsListRouteChildren: AuthedDashboardClaimsListRouteChildren =
  {
    AuthedDashboardClaimsListIndexRoute: AuthedDashboardClaimsListIndexRoute,
    AuthedDashboardClaimsListClaimIdFilesRoute:
      AuthedDashboardClaimsListClaimIdFilesRoute,
  }

const AuthedDashboardClaimsListRouteWithChildren =
  AuthedDashboardClaimsListRoute._addFileChildren(
    AuthedDashboardClaimsListRouteChildren,
  )

interface AuthedDashboardRouteChildren {
  AuthedDashboardReportingRouteRoute: typeof AuthedDashboardReportingRouteRouteWithChildren
  AuthedDashboardAssistantRoute: typeof AuthedDashboardAssistantRoute
  AuthedDashboardInboxRoute: typeof AuthedDashboardInboxRoute
  AuthedDashboardTravelAgencyRoute: typeof AuthedDashboardTravelAgencyRoute
  AuthedDashboardIndexRoute: typeof AuthedDashboardIndexRoute
  AuthedDashboardAdminToolsAgencyPaymentsRoute: typeof AuthedDashboardAdminToolsAgencyPaymentsRoute
  AuthedDashboardAdminToolsAllTasksRoute: typeof AuthedDashboardAdminToolsAllTasksRoute
  AuthedDashboardAdminToolsFeatureFlagsRoute: typeof AuthedDashboardAdminToolsFeatureFlagsRoute
  AuthedDashboardAdminToolsFinanceRoute: typeof AuthedDashboardAdminToolsFinanceRoute
  AuthedDashboardAdminToolsMassAbandonRoute: typeof AuthedDashboardAdminToolsMassAbandonRoute
  AuthedDashboardAdminToolsPaymentOrdersRoute: typeof AuthedDashboardAdminToolsPaymentOrdersRoute
  AuthedDashboardAdminToolsReportingRoute: typeof AuthedDashboardAdminToolsReportingRoute
  AuthedDashboardAdminToolsTimelineSearchRoute: typeof AuthedDashboardAdminToolsTimelineSearchRoute
  AuthedDashboardClaimsListRoute: typeof AuthedDashboardClaimsListRouteWithChildren
  AuthedDashboardClaimsCreateRoute: typeof AuthedDashboardClaimsCreateRoute
  AuthedDashboardAdminToolsIndexRoute: typeof AuthedDashboardAdminToolsIndexRoute
  AuthedDashboardAgenciesIndexRoute: typeof AuthedDashboardAgenciesIndexRoute
  AuthedDashboardCompaniesIndexRoute: typeof AuthedDashboardCompaniesIndexRoute
  AuthedDashboardProceduresIndexRoute: typeof AuthedDashboardProceduresIndexRoute
  AuthedDashboardSignaturesIndexRoute: typeof AuthedDashboardSignaturesIndexRoute
  AuthedDashboardTasksIndexRoute: typeof AuthedDashboardTasksIndexRoute
  AuthedDashboardUsersIndexRoute: typeof AuthedDashboardUsersIndexRoute
  AuthedDashboardClaimsClaimIdAcquisitionHistoryRoute: typeof AuthedDashboardClaimsClaimIdAcquisitionHistoryRoute
  AuthedDashboardClaimsClaimIdOverviewRoute: typeof AuthedDashboardClaimsClaimIdOverviewRoute
  AuthedDashboardClaimsClaimIdPassengersRoute: typeof AuthedDashboardClaimsClaimIdPassengersRoute
  AuthedDashboardClaimsClaimIdPnrDisplayRoute: typeof AuthedDashboardClaimsClaimIdPnrDisplayRoute
  AuthedDashboardClaimsClaimIdTimelineRoute: typeof AuthedDashboardClaimsClaimIdTimelineRoute
  AuthedDashboardClaimsClaimIdIndexRoute: typeof AuthedDashboardClaimsClaimIdIndexRoute
}

const AuthedDashboardRouteChildren: AuthedDashboardRouteChildren = {
  AuthedDashboardReportingRouteRoute:
    AuthedDashboardReportingRouteRouteWithChildren,
  AuthedDashboardAssistantRoute: AuthedDashboardAssistantRoute,
  AuthedDashboardInboxRoute: AuthedDashboardInboxRoute,
  AuthedDashboardTravelAgencyRoute: AuthedDashboardTravelAgencyRoute,
  AuthedDashboardIndexRoute: AuthedDashboardIndexRoute,
  AuthedDashboardAdminToolsAgencyPaymentsRoute:
    AuthedDashboardAdminToolsAgencyPaymentsRoute,
  AuthedDashboardAdminToolsAllTasksRoute:
    AuthedDashboardAdminToolsAllTasksRoute,
  AuthedDashboardAdminToolsFeatureFlagsRoute:
    AuthedDashboardAdminToolsFeatureFlagsRoute,
  AuthedDashboardAdminToolsFinanceRoute: AuthedDashboardAdminToolsFinanceRoute,
  AuthedDashboardAdminToolsMassAbandonRoute:
    AuthedDashboardAdminToolsMassAbandonRoute,
  AuthedDashboardAdminToolsPaymentOrdersRoute:
    AuthedDashboardAdminToolsPaymentOrdersRoute,
  AuthedDashboardAdminToolsReportingRoute:
    AuthedDashboardAdminToolsReportingRoute,
  AuthedDashboardAdminToolsTimelineSearchRoute:
    AuthedDashboardAdminToolsTimelineSearchRoute,
  AuthedDashboardClaimsListRoute: AuthedDashboardClaimsListRouteWithChildren,
  AuthedDashboardClaimsCreateRoute: AuthedDashboardClaimsCreateRoute,
  AuthedDashboardAdminToolsIndexRoute: AuthedDashboardAdminToolsIndexRoute,
  AuthedDashboardAgenciesIndexRoute: AuthedDashboardAgenciesIndexRoute,
  AuthedDashboardCompaniesIndexRoute: AuthedDashboardCompaniesIndexRoute,
  AuthedDashboardProceduresIndexRoute: AuthedDashboardProceduresIndexRoute,
  AuthedDashboardSignaturesIndexRoute: AuthedDashboardSignaturesIndexRoute,
  AuthedDashboardTasksIndexRoute: AuthedDashboardTasksIndexRoute,
  AuthedDashboardUsersIndexRoute: AuthedDashboardUsersIndexRoute,
  AuthedDashboardClaimsClaimIdAcquisitionHistoryRoute:
    AuthedDashboardClaimsClaimIdAcquisitionHistoryRoute,
  AuthedDashboardClaimsClaimIdOverviewRoute:
    AuthedDashboardClaimsClaimIdOverviewRoute,
  AuthedDashboardClaimsClaimIdPassengersRoute:
    AuthedDashboardClaimsClaimIdPassengersRoute,
  AuthedDashboardClaimsClaimIdPnrDisplayRoute:
    AuthedDashboardClaimsClaimIdPnrDisplayRoute,
  AuthedDashboardClaimsClaimIdTimelineRoute:
    AuthedDashboardClaimsClaimIdTimelineRoute,
  AuthedDashboardClaimsClaimIdIndexRoute:
    AuthedDashboardClaimsClaimIdIndexRoute,
}

const AuthedDashboardRouteWithChildren = AuthedDashboardRoute._addFileChildren(
  AuthedDashboardRouteChildren,
)

interface AuthedRouteChildren {
  AuthedOnboardingRouteRoute: typeof AuthedOnboardingRouteRouteWithChildren
  AuthedDashboardRoute: typeof AuthedDashboardRouteWithChildren
  AuthedDocumentsFileIdEditRoute: typeof AuthedDocumentsFileIdEditRoute
  AuthedDocumentsFileIdPdfRoute: typeof AuthedDocumentsFileIdPdfRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedOnboardingRouteRoute: AuthedOnboardingRouteRouteWithChildren,
  AuthedDashboardRoute: AuthedDashboardRouteWithChildren,
  AuthedDocumentsFileIdEditRoute: AuthedDocumentsFileIdEditRoute,
  AuthedDocumentsFileIdPdfRoute: AuthedDocumentsFileIdPdfRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
